/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { greetingConditionTypeEnumSchema } from "./greetingConditionTypeEnumSchema.ts";
import { z } from "zod";

export const createOrUpdateGreetingModelSchema = z.object({
    "name": z.string().max(150).describe("Название"),
"title": z.string().max(150).describe("Заголовок"),
"description": z.string().max(2000).describe("Описание"),
"conditionType": z.lazy(() => greetingConditionTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Everyday</b>: Ежедневно</li>\n<li><b>2 - OnDate</b>: На дату</li>\n<li><b>3 - OnPeriod</b>: На период</li>\n</ul>\n"),
"sendOnStartDate": z.string().date().describe("Начальная дата показа (для условий показа - ежегодно/один раз).\r\nДля условия показа \"ежегодно\" год опускается").nullable().nullish(),
"sendOnEndDate": z.string().date().describe("Конечная дата показа (для условий показа - ежегодно/один раз).\r\nДля условия показа \"ежегодно\" год опускается").nullable().nullish()
    })